import { gql } from '@apollo/client';
const MARK_ALL_NOTIFICATIONS_AS_READ = gql `
  mutation MarkAllNotificationsAsRead {
    markAllNotificationsAsRead
  }
`;
export default MARK_ALL_NOTIFICATIONS_AS_READ;
